import request from '@/utils/request'

export function carHailingFun(obj){
    console.log(obj)
   return request({
       url:'/webapi/authority/order/addOrder',
       method:'POST',
       data:obj
   })
}

export function pathPrice(obj){
    return request({
        url:'/webapi/authority/order/getOrderFee',
       method:'POST',
       data:obj
    })  
}

export function companyIdFun(id){
    return request({
        url:'/webapi/company/checkCompany',
        method:'GET',
        params:{companyId:id}        
    })
}


export function getAreaListFun(){
    return request({
        url:'/webapi/area/getAreaList',
        method:'GET'
    })
}

//查询订单
export function selectOrderFun(){
    return request({
        url:'/webapi/authority/order/selectOrder',
        method:'GET'
    })
}
